export default __webpack_public_path__ + "static/media/logo_bl.d92df853.png";